import { HCConfigFeatures, HCConfigRules } from 'src/hc-config/hc-config';
import { HcService } from './hc-service';

interface IHasHcService {
  hcService: HcService;
}

// Property decorators that turn a field declaration into a live getter reading HcService,
// instead of hand-writing `public get x(): boolean { return this.hcService.hasFeature(...); }`.
// The decorated class must expose an `hcService: HcService` property (any visibility).
//
//   @HcFeature(HCConfigFeatures.PATIENT_INVITE_AND_EDIT_FORM_INCLUDE_CNS)
//   public readonly hcHasCns: boolean;
//
// Declare the field WITHOUT an initializer - the decorator defines the getter on the
// prototype, so an initializer would just be dead code (and, if the field were ever assigned
// to instead of read, would throw at runtime since there's no setter).
export function HcFeature(...features: HCConfigFeatures[]): PropertyDecorator {
  return (target: Record<string, unknown>, propertyKey: string | symbol) => {
    Object.defineProperty(target, propertyKey, {
      get(this: IHasHcService): boolean {
        return this.hcService.hasFeature(...features);
      },
      enumerable: true,
      configurable: true,
    });
  };
}

export function HcRule(...rules: HCConfigRules[]): PropertyDecorator {
  return (target: Record<string, unknown>, propertyKey: string | symbol) => {
    Object.defineProperty(target, propertyKey, {
      get(this: IHasHcService): boolean {
        return this.hcService.hasRule(...rules);
      },
      enumerable: true,
      configurable: true,
    });
  };
}
